export const actionConstants = {
  LOGO_HAS_UPDATED: 'LOGO_HAS_UPDATED',
  PASSWORD_IS_EXPIRED: 'PASSWORD_IS_EXPIRED',
  NEED_LOGOUT: 'NEED_LOGOUT',
  CLEAR_DATA: 'CLEAR_DATA',
  CLEAR_ERROR: 'CLEAR_ERROR',
  RESET_COMPLETED: 'RESET_COMPLETED',
  RESET_COMPLETED_FLAG: 'RESET_COMPLETED_FLAG',
  START_QUERY: 'ACTION_START_QUERY',
  END_QUERY: 'ACTION_END_QUERY',
  START_SUBMISSION: 'START_SUBMISSION',
  END_SUBMISSION: 'END_SUBMISSION',
  START_FETCHING: 'START_FETCHING',
  END_FETCHING: 'END_FETCHING',
  INIT_STATE: 'INIT_STATE',

  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGIN_SUCCESS: 'ACTION_LOGIN_SUCCESS',
  LOGIN_FAILURE: 'ACTION_LOGIN_FAILURE',

  LOGOUT_REQUEST: 'ACTION_LOGOUT_REQUEST',

  REGISTER_SUCCESS: 'ACTION_REGISTER_SUCCESS',
  REGISTER_FAILURE: 'ACTION_REGISTER_FAILURE',

  GET_ALARM_LIST_SUCCESS: 'GET_ALARM_LIST_SUCCESS',
  GET_ALARM_LIST_FAILURE: 'GET_ALARM_LIST_FAILURE',
  GET_ALARM_LIST_BY_MC_SUCCESS: 'GET_ALARM_LIST_BY_MC_SUCCESS',
  GET_ALARM_LIST_BY_MC_FAILURE: 'GET_ALARM_LIST_BY_MC_FAILURE',
  GET_AVAILABLE_GROUPS_SUCCESS: 'GET_AVAILABLE_GROUPS_SUCCESS',
  GET_AVAILABLE_GROUPS_FAILURE: 'GET_AVAILABLE_GROUPS_FAILURE',
  GET_AVAILABLE_GROUPS_SUMMARIES_SUCCESS:
    'GET_AVAILABLE_GROUPS_SUMMARIES_SUCCESS',
  GET_AVAILABLE_GROUPS_SUMMARIES_FAILURE:
    'GET_AVAILABLE_GROUPS_SUMMARIES_FAILURE',
  GET_ACK_ALARMS_SUCCESS: 'GET_ACK_ALARMS_SUCCESS',
  GET_ACK_ALARMS_FAILURE: 'GET_ACK_ALARMS_FAILURE',
  GET_ACK_ALARMS_PHRASES_SUCCESS: 'GET_ACK_ALARMS_PHRASES_SUCCESS',
  GET_ACK_ALARMS_PHRASES_FAILURE: 'GET_ACK_ALARMS_PHRASES_FAILURE',
  GET_ACK_INFO_SUCCESS: 'GET_ACK_INFO_SUCCESS',
  GET_ACK_INFO_FAILURE: 'GET_ACK_INFO_FAILURE',
  CREATE_ACK_ALARMS_SUCCESS: 'CREATE_ACK_ALARMS_SUCCESS',
  CREATE_ACK_ALARMS_FAILURE: 'CREATE_ACK_ALARMS_FAILURE',
  ADD_NOTE_SUCCESS: 'ADD_NOTE_SUCCESS',
  ADD_NOTE_FAILURE: 'ADD_NOTE_FAILURE',
  GET_TREND_SUCCESS: 'GET_TREND_SUCCESS',
  GET_TREND_FAILURE: 'GET_TREND_FAILURE',

  GET_USERS_SUCCESS: 'ACTION_GET_USERS_SUCCESS',
  GET_USERS_FAILURE: 'ACTION_GET_USERS_FAILURE',

  INVITE_USER_SUCCESS: 'ACTION_INVITE_SUCCESS',
  INVITE_USER_FAILURE: 'ACTION_INVITE_FAILURE',

  GET_INVITATIONS_SUCCESS: 'ACTION_GET_INVITATIONS_SUCCESS',
  GET_INVITATIONS_FAILURE: 'ACTION_GET_INVITATIONS_FAILURE',

  QUERY_INVITATION_SUCCESS: 'ACTION_QUERY_INVITATION_SUCCESS',
  QUERY_INVITATION_FAILURE: 'ACTION_QUERY_INVITATION_FAILURE',

  RESET_PASSWORD_SUCCESS: 'ACTION_RESET_PASSWORD_SUCCESS',
  RESET_PASSWORD_FAILURE: 'ACTION_RESET_PASSWORD_FAILURE',
  CHANGE_PASSWORD_FAILURE: 'CHANGE_PASSWORD_FAILURE',

  GET_TENANTS_REQUEST: 'ACTION_GET_TENANTS_REQUEST',
  GET_TENANTS_SUCCESS: 'ACTION_GET_TENANTS_SUCCESS',
  GET_TENANTS_FAILURE: 'ACTION_GET_TENANTS_FAILURE',

  CREATE_TENANT_SUCCESS: 'ACTION_CREATE_TENANTS_SUCCESS',
  CREATE_TENANT_FAILURE: 'ACTION_CREATE_TENANTS_FAILURE',

  GET_SITES_SUCCESS: 'GET_SITES_SUCCESS',
  GET_SITES_FAILURE: 'GET_SITES_FAILURE',
  CREATE_SITE_SUCCESS: 'CREATE_SITE_SUCCESS',
  CREATE_SITE_FAILURE: 'CREATE_SITE_FAILURE',
  EDIT_SITE_SUCCESS: 'EDIT_SITE_SUCCESS',
  EDIT_SITE_FAILURE: 'EDIT_SITE_FAILURE',
  DELETE_SITE_SUCCESS: 'DELETE_SITE_SUCCESS',
  DELETE_SITE_FAILURE: 'DELETE_SITE_FAILURE',

  GET_AREAS_SUCCESS: 'GET_AREAS_SUCCESS',
  GET_AREAS_FAILURE: 'GET_AREAS_FAILURE',
  CREATE_AREA_SUCCESS: 'CREATE_AREA_SUCCESS',
  CREATE_AREA_FAILURE: 'CREATE_AREA_FAILURE',
  EDIT_AREA_SUCCESS: 'EDIT_AREA_SUCCESS',
  EDIT_AREA_FAILURE: 'EDIT_AREA_FAILURE',
  DELETE_AREA_SUCCESS: 'DELETE_AREA_SUCCESS',
  DELETE_AREA_FAILURE: 'DELETE_AREA_FAILURE',

  GET_DEPARTMENTS_SUCCESS: 'GET_DEPARTMENTS_SUCCESS',
  GET_DEPARTMENTS_FAILURE: 'GET_DEPARTMENTS_FAILURE',
  GET_DEPARTMENT_SUCCESS: 'GET_DEPARTMENT_SUCCESS',
  GET_DEPARTMENT_FAILURE: 'GET_DEPARTMENT_FAILURE',
  CREATE_DEPARTMENT_SUCCESS: 'CREATE_DEPARTMENT_SUCCESS',
  CREATE_DEPARTMENT_FAILURE: 'CREATE_DEPARTMENT_FAILURE',
  EDIT_DEPARTMENT_SUCCESS: 'EDIT_DEPARTMENT_SUCCESS',
  EDIT_DEPARTMENT_FAILURE: 'EDIT_DEPARTMENT_FAILURE',
  DELETE_DEPARTMENT_SUCCESS: 'DELETE_DEPARTMENT_SUCCESS',
  DELETE_DEPARTMENT_FAILURE: 'DELETE_DEPARTMENT_FAILURE',
  GET_DEPT_SETTINGS_BY_LOCALE_SUCCESS: 'GET_DEPT_SETTINGS_BY_LOCALE_SUCCESS',
  GET_DEPT_SETTINGS_BY_LOCALE_FAILURE: 'GET_DEPT_SETTINGS_BY_LOCALE_FAILURE',
  GET_DEPT_SETTINGS_BY_PARAM_SUCCESS: 'GET_DEPT_SETTINGS_BY_PARAM_SUCCESS',
  GET_DEPT_SETTINGS_BY_PARAM_FAILURE: 'GET_DEPT_SETTINGS_BY_PARAM_FAILURE',
  DEPARTMENT_SETTINGS_SUCCESS: 'DEPARTMENT_SETTINGS_SUCCESS',
  DEPARTMENT_SETTINGS_FAILURE: 'DEPARTMENT_SETTINGS_FAILURE',

  GET_GROUPS_SUCCESS: 'GET_GROUPS_SUCCESS',
  GET_GROUPS_FAILURE: 'GET_GROUPS_FAILURE',
  GET_GROUP_SUCCESS: 'GET_GROUP_SUCCESS',
  GET_GROUP_FAILURE: 'GET_GROUP_FAILURE',
  CREATE_GROUP_SUCCESS: 'CREATE_GROUP_SUCCESS',
  CREATE_GROUP_FAILURE: 'CREATE_GROUP_FAILURE',
  GET_USERS_BY_GROUP_SUCCESS: 'GET_USERS_BY_GROUP_SUCCESS',
  GET_USERS_BY_GROUP_FAILURE: 'GET_USERS_BY_GROUP_FAILURE',
  ASSIGN_USERS_SUCCESS: 'ASSIGN_USERS_SUCCESS',
  ASSIGN_USERS_FAILURE: 'ASSIGN_USERS_FAILURE',
  UNASSIGN_USERS_SUCCESS: 'UNASSIGN_USERS_SUCCESS',
  UNASSIGN_USERS_FAILURE: 'UNASSIGN_USERS_FAILURE',
  ASSIGN_ALERTS_FAILURE: 'ASSIGN_ALERTS_FAILURE',
  EDIT_GROUP_SUCCESS: 'EDIT_GROUP_SUCCESS',
  EDIT_GROUP_FAILURE: 'EDIT_GROUP_FAILURE',
  DELETE_GROUP_SUCCESS: 'DELETE_GROUP_SUCCESS',
  DELETE_GROUP_FAILURE: 'DELETE_GROUP_FAILURE',

  GET_MAP_PAGES_SUCCESS: 'GET_MAP_PAGES_SUCCESS',
  GET_MAP_PAGES_FAILURE: 'GET_MAP_PAGES_FAILURE',

  CLEAR_PHRASES: 'CLEAR_PHRASES',
  GETTING_PHRASES: 'GETTING_PHRASES',
  GET_PHRASES_SUCCESS: 'GET_PHRASES_SUCCESS',
  GET_PHRASES_FAILURE: 'GET_PHRASES_FAILURE',
  GET_PHRASE_SUCCESS: 'GET_PHRASE_SUCCESS',
  GET_PHRASE_FAILURE: 'GET_PHRASE_FAILURE',
  CREATE_PHRASE_SUCCESS: 'CREATE_PHRASE_SUCCESS',
  CREATE_PHRASE_FAILURE: 'CREATE_PHRASE_FAILURE',
  EDIT_PHRASE_SUCCESS: 'EDIT_PHRASE_SUCCESS',
  EDIT_PHRASE_FAILURE: 'EDIT_PHRASE_FAILURE',
  DELETE_PHRASE_SUCCESS: 'DELETE_PHRASE_SUCCESS',
  DELETE_PHRASE_FAILURE: 'DELETE_PHRASE_FAILURE',

  GET_ROLES_SUCCESS: 'GET_ROLES_SUCCESS',
  GET_ROLES_FAILURE: 'GET_ROLES_FAILURE',
  GET_ROLE_SUCCESS: 'GET_ROLE_SUCCESS',
  GET_ROLE_FAILURE: 'GET_ROLE_FAILURE',
  CREATE_ROLE_SUCCESS: 'CREATE_ROLE_SUCCESS',
  CREATE_ROLE_FAILURE: 'CREATE_ROLE_FAILURE',
  EDIT_ROLE_SUCCESS: 'EDIT_ROLE_SUCCESS',
  EDIT_ROLE_FAILURE: 'EDIT_ROLE_FAILURE',
  DELETE_ROLE_SUCCESS: 'DELETE_ROLE_SUCCESS',
  DELETE_ROLE_FAILURE: 'DELETE_ROLE_FAILURE',
  GET_PERMISSIONS_SUCCESS: 'GET_PERMISSIONS_SUCCESS',
  GET_PERMISSIONS_FAILURE: 'GET_PERMISSIONS_FAILURE',
  GET_PERMISSIONS_BY_ROLE_SUCCESS: 'GET_PERMISSIONS_BY_ROLE_SUCCESS',
  GET_PERMISSIONS_BY_ROLE_FAILURE: 'GET_PERMISSIONS_BY_ROLE_FAILURE',
  UPDATE_PERMISSIONS_SUCCESS: 'UPDATE_PERMISSIONS_SUCCESS',
  UPDATE_PERMISSIONS_FAILURE: 'UPDATE_PERMISSIONS_FAILURE',

  GET_SCHEDULED_REPORTS_SUCCESS: 'GET_SCHEDULED_REPORTS_SUCCESS',
  GET_SCHEDULED_REPORTS_FAILURE: 'GET_SCHEDULED_REPORTS_FAILURE',
  GET_SCHEDULED_REPORT_SUCCESS: 'GET_SCHEDULED_REPORT_SUCCESS',
  GET_SCHEDULED_REPORT_FAILURE: 'GET_SCHEDULED_REPORT_FAILURE',
  CREATE_SCHEDULED_REPORT_SUCCESS: 'CREATE_SCHEDULED_REPORT_SUCCESS',
  CREATE_SCHEDULED_REPORT_FAILURE: 'CREATE_SCHEDULED_REPORT_FAILURE',
  EDIT_SCHEDULED_REPORT_SUCCESS: 'EDIT_SCHEDULED_REPORT_SUCCESS',
  EDIT_SCHEDULED_REPORT_FAILURE: 'EDIT_SCHEDULED_REPORT_FAILURE',
  DELETE_SCHEDULED_REPORT_SUCCESS: 'DELETE_SCHEDULED_REPORT_SUCCESS',
  DELETE_SCHEDULED_REPORT_FAILURE: 'DELETE_SCHEDULED_REPORT_FAILURE',

  GETTING_UNITS: 'GETTING_UNITS',
  GET_UNITS_SUCCESS: 'GET_UNITS_SUCCESS',
  GET_UNITS_FAILURE: 'GET_UNITS_FAILURE',
  GET_UNIT_SUCCESS: 'GET_UNIT_SUCCESS',
  GET_UNIT_FAILURE: 'GET_UNIT_FAILURE',
  CREATE_UNIT_SUCCESS: 'CREATE_UNIT_SUCCESS',
  CREATE_UNIT_FAILURE: 'CREATE_UNIT_FAILURE',

  GET_USERS_CONFIG_SUCCESS: 'GET_USERS_CONFIG_SUCCESS',
  GET_USERS_CONFIG_FAILURE: 'GET_USERS_CONFIG_FAILURE',
  GET_USER_CONFIG_SUCCESS: 'GET_USER_CONFIG_SUCCESS',
  GET_USER_CONFIG_FAILURE: 'GET_USER_CONFIG_FAILURE',
  CREATE_USER_CONFIG_SUCCESS: 'CREATE_USER_CONFIG_SUCCESS',
  CREATE_USER_CONFIG_FAILURE: 'CREATE_USER_CONFIG_FAILURE',
  EDIT_USER_CONFIG_SUCCESS: 'EDIT_USER_CONFIG_SUCCESS',
  EDIT_USER_CONFIG_FAILURE: 'EDIT_USER_CONFIG_FAILURE',

  CLEAR_ALARM_INDICATORS: 'CLEAR_ALARM_INDICATORS',
  GET_ALARM_INDICATORS_SUCCESS: 'GET_ALARM_INDICATORS_SUCCESS',
  GET_ALARM_INDICATORS_FAILURE: 'GET_ALARM_INDICATORS_FAILURE',
  GET_ALARM_INDICATORS_BY_DEPT_SUCCESS: 'GET_ALARM_INDICATORS_BY_DEPT_SUCCESS',
  GET_ALARM_INDICATORS_BY_DEPT_FAILURE: 'GET_ALARM_INDICATORS_BY_DEPT_FAILURE',
  GET_ALARM_INDICATORS_ALARM_MAPS_SUCCESS:
    'GET_ALARM_INDICATORS_ALARM_MAPS_SUCCESS',
  GET_ALARM_INDICATORS_ALARM_MAPS_FAILURE:
    'GET_ALARM_INDICATORS_ALARM_MAPS_FAILURE',
  CONFIG_ALARM_INDICATOR_SUCCESS: 'CONFIG_ALARM_INDICATOR_SUCCESS',
  CONFIG_ALARM_INDICATOR_FAILURE: 'CONFIG_ALARM_INDICATOR_FAILURE',
  CREATE_ALARM_INDICATOR_SUCCESS: 'CREATE_ALARM_INDICATOR_SUCCESS',
  CREATE_ALARM_INDICATOR_FAILURE: 'CREATE_ALARM_INDICATOR_FAILURE',

  GET_REMOTE_DEVICES_SUCCESS: 'GET_REMOTE_DEVICES_SUCCESS',
  GET_REMOTE_DEVICES_FAILURE: 'GET_REMOTE_DEVICES_FAILURE',
  GET_REMOTE_DEVICES_BY_DEPT_SUCCESS: 'GET_REMOTE_DEVICES_BY_DEPT_SUCCESS',
  GET_REMOTE_DEVICES_BY_DEPT_FAILURE: 'GET_REMOTE_DEVICES_BY_DEPT_FAILURE',
  GET_REMOTE_DEVICE_SUCCESS: 'GET_REMOTE_DEVICE_SUCCESS',
  GET_REMOTE_DEVICE_FAILURE: 'GET_REMOTE_DEVICE_FAILURE',
  CREATE_REMOTE_DEVICE_SUCCESS: 'CREATE_REMOTE_DEVICE_SUCCESS',
  CREATE_REMOTE_DEVICE_FAILURE: 'CREATE_REMOTE_DEVICE_FAILURE',
  EDIT_REMOTE_DEVICE_SUCCESS: 'EDIT_REMOTE_DEVICE_SUCCESS',
  EDIT_REMOTE_DEVICE_FAILURE: 'EDIT_REMOTE_DEVICE_FAILURE',
  DELETE_REMOTE_DEVICE_SUCCESS: 'DELETE_REMOTE_DEVICE_SUCCESS',
  DELETE_REMOTE_DEVICE_FAILURE: 'DELETE_REMOTE_DEVICE_FAILURE',

  CLEAR_SENSORS: 'CLEAR_SENSORS',
  START_GETTING_SENSORS: 'START_GETTING_SENSORS',
  END_GETTING_SENSORS: 'END_GETTING_SENSORS',
  GET_SENSORS_BY_DEPT_SUCCESS: 'GET_SENSORS_BY_DEPT_SUCCESS',
  GET_SENSORS_BY_DEPT_FAILURE: 'GET_SENSORS_BY_DEPT_FAILURE',
  GET_SENSORS_MV_BY_GROUP_SUCCESS: 'GET_SENSORS_MV_BY_GROUP_SUCCESS',
  GET_SENSORS_MV_BY_GROUP_FAILURE: 'GET_SENSORS_MV_BY_GROUP_FAILURE',
  DISABLE_SENSOR_SUCCESS: 'DISABLE_SENSOR_SUCCESS',
  DISABLE_SENSOR_FAILURE: 'DISABLE_SENSOR_FAILURE',
  ENABLE_SENSOR_SUCCESS: 'ENABLE_SENSOR_SUCCESS',
  ENABLE_SENSOR_FAILURE: 'ENABLE_SENSOR_FAILURE',
  GET_SENSOR_DETAIL_SUCCESS: 'GET_SENSOR_DETAIL_SUCCESS',
  GET_SENSOR_DETAIL_FAILURE: 'GET_SENSOR_DETAIL_FAILURE',
  EDIT_SENSOR_SUCCESS: 'EDIT_SENSOR_SUCCESS',
  EDIT_SENSOR_FAILURE: 'EDIT_SENSOR_FAILURE',
  GET_ASSIGNED_SENSORS_SUCCESS: 'GET_ASSIGNED_SENSORS_SUCCESS',
  GET_ASSIGNED_SENSORS_FAILURE: 'GET_ASSIGNED_SENSORS_FAILURE',
  GET_UNASSIGNED_SENSORS_SUCCESS: 'GET_UNASSIGNED_SENSORS_SUCCESS',
  GET_UNASSIGNED_SENSORS_FAILURE: 'GET_UNASSIGNED_SENSORS_FAILURE',
  ASSIGN_SENSORS_SUCCESS: 'ASSIGN_SENSORS_SUCCESS',
  ASSIGN_SENSORS_FAILURE: 'ASSIGN_SENSORS_FAILURE',
  UNASSIGN_SENSORS_SUCCESS: 'UNASSIGN_SENSORS_SUCCESS',
  UNASSIGN_SENSORS_FAILURE: 'UNASSIGN_SENSORS_FAILURE',
  DELETE_ASSIGNED_SENSORS_SUCCESS: 'DELETE_ASSIGNED_SENSORS_SUCCESS',
  DELETE_ASSIGNED_SENSORS_FAILURE: 'DELETE_ASSIGNED_SENSORS_FAILURE',
  REPLACE_SENSOR_SUCCESS: 'REPLACE_SENSOR_SUCCESS',
  REPLACE_SENSOR_FAILURE: 'REPLACE_SENSOR_FAILURE',
  UPDATE_ACTIVE_SENSOR_SUCCESS: 'UPDATE_ACTIVE_SENSOR_SUCCESS',
  UPDATE_ACTIVE_SENSOR_FAILURE: 'UPDATE_ACTIVE_SENSOR_FAILURE',
  UPDATE_ALERTS_SENSOR_SUCCESS: 'UPDATE_ALERTS_SENSOR_SUCCESS',
  UPDATE_ALERTS_SENSOR_FAILURE: 'UPDATE_ALERTS_SENSOR_FAILURE',
  GET_ALARM_STATUS_SUCCESS: 'GET_ALARM_STATUS_SUCCESS',
  GET_ALARM_STATUS_FAILURE: 'GET_ALARM_STATUS_FAILURE',
  GET_ALARM_STATUS_BY_GROUP_SUCCESS: 'GET_ALARM_STATUS_BY_GROUP_SUCCESS',
  GET_ALARM_STATUS_BY_GROUP_FAILURE: 'GET_ALARM_STATUS_BY_GROUP_FAILURE',
  GET_SENSORS_INFO_SUCCESS: 'GET_SENSORS_INFO_SUCCESS',
  GET_SENSORS_INFO_FAILURE: 'GET_SENSORS_INFO_FAILURE',

  CLEAR_SENSOR_TYPES: 'CLEAR_SENSOR_TYPES',
  GET_SENSOR_TYPES_SUCCESS: 'GET_SENSOR_TYPES_SUCCESS',
  GET_SENSOR_TYPES_FAILURE: 'GET_SENSOR_TYPES_FAILURE',
  GET_SENSOR_TYPE_SUCCESS: 'GET_SENSOR_TYPE_SUCCESS',
  GET_SENSOR_TYPE_FAILURE: 'GET_SENSOR_TYPE_FAILURE',
  GET_SENSOR_TYPES_BY_GROUP_SUCCESS: 'GET_SENSOR_TYPES_BY_GROUP_SUCCESS',
  GET_SENSOR_TYPES_BY_GROUP_FAILURE: 'GET_SENSOR_TYPES_BY_GROUP_FAILURE',
  GET_SENSOR_TYPES_BY_SCHEDULED_SUCCESS:
    'GET_SENSOR_TYPES_BY_SCHEDULED_SUCCESS',
  GET_SENSOR_TYPES_BY_SCHEDULED_FAILURE:
    'GET_SENSOR_TYPES_BY_SCHEDULED_FAILURE',
  CREATE_SENSOR_TYPE_SUCCESS: 'CREATE_SENSOR_TYPE_SUCCESS',
  CREATE_SENSOR_TYPE_FAILURE: 'CREATE_SENSOR_TYPE_FAILURE',
  EDIT_SENSOR_TYPE_SUCCESS: 'EDIT_SENSOR_TYPE_SUCCESS',
  EDIT_SENSOR_TYPE_FAILURE: 'EDIT_SENSOR_TYPE_FAILURE',
  DELETE_SENSOR_TYPE_SUCCESS: 'DELETE_SENSOR_TYPE_SUCCESS',
  DELETE_SENSOR_TYPE_FAILURE: 'DELETE_SENSOR_TYPE_FAILURE',

  GET_VCP_SUCCESS: 'GET_VCP_SUCCESS',
  GET_VCP_FAILURE: 'GET_VCP_FAILURE',
  START_OVERRIDE_NORMAL: 'START_OVERRIDE_NORMAL',
  END_OVERRIDE_NORMAL: 'END_OVERRIDE_NORMAL',
  OVERRIDE_VCP_SUCCESS: 'OVERRIDE_VCP_SUCCESS',
  OVERRIDE_VCP_FAILURE: 'OVERRIDE_VCP_FAILURE',
  NORMAL_VCP_SUCCESS: 'NORMAL_VCP_SUCCESS',
  NORMAL_VCP_FAILURE: 'NORMAL_VCP_FAILURE',

  GET_MOBILE_CONFIGS_SUCCESS: 'GET_MOBILE_CONFIGS_SUCCESS',
  GET_MOBILE_CONFIGS_FAILURE: 'GET_MOBILE_CONFIGS_FAILURE',
  GET_MOBILE_CONFIGS_BY_DEPT_SUCCESS: 'GET_MOBILE_CONFIGS_BY_DEPT_SUCCESS',
  GET_MOBILE_CONFIGS_BY_DEPT_FAILURE: 'GET_MOBILE_CONFIGS_BY_DEPT_FAILURE',
  GET_MOBILE_CONFIG_SUCCESS: 'GET_MOBILE_CONFIG_SUCCESS',
  GET_MOBILE_CONFIG_FAILURE: 'GET_MOBILE_CONFIG_FAILURE',
  CREATE_MOBILE_CONFIG_SUCCESS: 'CREATE_MOBILE_CONFIG_SUCCESS',
  CREATE_MOBILE_CONFIG_FAILURE: 'CREATE_MOBILE_CONFIG_FAILURE',
  EDIT_MOBILE_CONFIG_SUCCESS: 'EDIT_MOBILE_CONFIG_SUCCESS',
  EDIT_MOBILE_CONFIG_FAILURE: 'EDIT_MOBILE_CONFIG_FAILURE',
  DELETE_MOBILE_CONFIG_SUCCESS: 'DELETE_MOBILE_CONFIG_SUCCESS',
  DELETE_MOBILE_CONFIG_FAILURE: 'DELETE_MOBILE_CONFIG_FAILURE',
  SENSORS_BY_MOBILE_CONFIG_SUCCESS: 'SENSORS_BY_MOBILE_CONFIG_SUCCESS',
  SENSORS_BY_MOBILE_CONFIG_FAILURE: 'SENSORS_BY_MOBILE_CONFIG_FAILURE',
  CONFIG_MOBILE_SENSORS_SUCCESS: 'CONFIG_MOBILE_SENSORS_SUCCESS',
  CONFIG_MOBILE_SENSORS_FAILURE: 'CONFIG_MOBILE_SENSORS_FAILURE',

  GETTING_MAPS: 'GETTING_MAPS',
  GET_MAP_IMAGE_SUCCESS: 'GET_MAP_IMAGE_SUCCESS',
  GET_MAP_IMAGE_FAILURE: 'GET_MAP_IMAGE_FAILURE',
  GET_MAP_SHAPES_SUCCESS: 'GET_MAP_SHAPES_SUCCESS',
  GET_MAP_SHAPES_FAILURE: 'GET_MAP_SHAPES_FAILURE',
  GET_MAPS_BY_DEPT_SUCCESS: 'GET_MAPS_BY_DEPT_SUCCESS',
  GET_MAPS_BY_DEPT_FAILURE: 'GET_MAPS_BY_DEPT_FAILURE',

  CLEAR_REPORT: 'CLEAR_REPORT',
  START_QUERY_REPORT: 'START_QUERY_REPORT',
  END_QUERY_REPORT: 'END_QUERY_REPORT',
  GETTING_REPORT: 'GETTING_REPORT',
  GET_ALARM_HISTORY_SUCCESS: 'GET_ALARM_HISTORY_SUCCESS',
  GET_ALARM_HISTORY_FAILURE: 'GET_ALARM_HISTORY_FAILURE',
  GET_AUDIT_REPORTS_SUCCESS: 'GET_AUDIT_REPORTS_SUCCESS',
  GET_AUDIT_REPORTS_FAILURE: 'GET_AUDIT_REPORTS_FAILURE',
  DOWNLOAD_BATCH_REPORT_SUCCESS: 'DOWNLOAD_BATCH_REPORT_SUCCESS',
  DOWNLOAD_BATCH_REPORT_FAILURE: 'DOWNLOAD_BATCH_REPORT_FAILURE',
  GET_BATCH_REPORTS_SUCCESS: 'GET_BATCH_REPORTS_SUCCESS',
  GET_BATCH_REPORTS_FAILURE: 'GET_BATCH_REPORTS_FAILURE',
  GET_BATCH_REPORT_SUCCESS: 'GET_BATCH_REPORT_SUCCESS',
  GET_BATCH_REPORT_FAILURE: 'GET_BATCH_REPORT_FAILURE',
  GET_BATCH_REPORTS_BY_DEPT_SUCCESS: 'GET_BATCH_REPORTS_BY_DEPT_SUCCESS',
  GET_BATCH_REPORTS_BY_DEPT_FAILURE: 'GET_BATCH_REPORTS_BY_DEPT_FAILURE',
  CREATE_BATCH_REPORT_SUCCESS: 'CREATE_BATCH_REPORT_SUCCESS',
  CREATE_BATCH_REPORT_FAILURE: 'CREATE_BATCH_REPORT_FAILURE',
  EDIT_BATCH_REPORT_SUCCESS: 'EDIT_BATCH_REPORT_SUCCESS',
  EDIT_BATCH_REPORT_FAILURE: 'EDIT_BATCH_REPORT_FAILURE',
  DELETE_BATCH_REPORT_SUCCESS: 'DELETE_BATCH_REPORT_SUCCESS',
  DELETE_BATCH_REPORT_FAILURE: 'DELETE_BATCH_REPORT_FAILURE',
  GET_BATCH_PROCESSES_SUCCESS: 'GET_BATCH_PROCESSES_SUCCESS',
  GET_BATCH_PROCESSES_FAILURE: 'GET_BATCH_PROCESSES_FAILURE',
  GET_BATCH_PROCESS_SUCCESS: 'GET_BATCH_PROCESS_SUCCESS',
  GET_BATCH_PROCESS_FAILURE: 'GET_BATCH_PROCESS_FAILURE',
  CREATE_BATCH_PROCESS_SUCCESS: 'CREATE_BATCH_PROCESS_SUCCESS',
  CREATE_BATCH_PROCESS_FAILURE: 'CREATE_BATCH_PROCESS_FAILURE',
  EDIT_BATCH_PROCESS_SUCCESS: 'EDIT_BATCH_PROCESS_SUCCESS',
  EDIT_BATCH_PROCESS_FAILURE: 'EDIT_BATCH_PROCESS_FAILURE',
  DELETE_BATCH_PROCESS_SUCCESS: 'DELETE_BATCH_PROCESS_SUCCESS',
  DELETE_BATCH_PROCESS_FAILURE: 'DELETE_BATCH_PROCESS_FAILURE',
  GET_GROUP_STATUS_SUCCESS: 'GET_GROUP_STATUS_SUCCESS',
  GET_GROUP_STATUS_FAILURE: 'GET_GROUP_STATUS_FAILURE',
  GET_GROUP_STATUS_STATISTICS_SUCCESS: 'GET_GROUP_STATUS_STATISTICS_SUCCESS',
  GET_GROUP_STATUS_STATISTICS_FAILURE: 'GET_GROUP_STATUS_STATISTICS_FAILURE',
  GET_LIMITS_CHANGED_SUCCESS: 'GET_LIMITS_CHANGED_SUCCESS',
  GET_LIMITS_CHANGED_FAILURE: 'GET_LIMITS_CHANGED_FAILURE',
  GET_MKT_MONITORS_SUCCESS: 'GET_MKT_MONITORS_SUCCESS',
  GET_MKT_MONITORS_FAILURE: 'GET_MKT_MONITORS_FAILURE',
  GET_MKT_MONITOR_SUCCESS: 'GET_MKT_MONITOR_SUCCESS',
  GET_MKT_MONITOR_FAILURE: 'GET_MKT_MONITOR_FAILURE',
  CREATE_MKT_MONITOR_SUCCESS: 'CREATE_MKT_MONITOR_SUCCESS',
  CREATE_MKT_MONITOR_FAILURE: 'CREATE_MKT_MONITOR_FAILURE',
  EDIT_MKT_MONITOR_SUCCESS: 'EDIT_MKT_MONITOR_SUCCESS',
  EDIT_MKT_MONITOR_FAILURE: 'EDIT_MKT_MONITOR_FAILURE',
  DELETE_MKT_MONITOR_SUCCESS: 'DELETE_MKT_MONITOR_SUCCESS',
  DELETE_MKT_MONITOR_FAILURE: 'DELETE_MKT_MONITOR_FAILURE',
  GET_SM_LOG_SUCCESS: 'GET_SM_LOG_SUCCESS',
  GET_SM_LOG_FAILURE: 'GET_SM_LOG_FAILURE',
  DOWNLOAD_FILE_SUCCESS: 'DOWNLOAD_FILE_SUCCESS',
  DOWNLOAD_FILE_FAILURE: 'DOWNLOAD_FILE_FAILURE',
  GET_STATISTICS_SUMMARY_SUCCESS: 'GET_STATISTICS_SUMMARY_SUCCESS',
  GET_STATISTICS_SUMMARY_FAILURE: 'GET_STATISTICS_SUMMARY_FAILURE',
  GET_STATISTICS_CHART_SUCCESS: 'GET_STATISTICS_CHART_SUCCESS',
  GET_STATISTICS_CHART_FAILURE: 'GET_STATISTICS_CHART_FAILURE',
  GET_STATISTICS_DETAILS_SUCCESS: 'GET_STATISTICS_DETAILS_SUCCESS',
  GET_STATISTICS_DETAILS_FAILURE: 'GET_STATISTICS_DETAILS_FAILURE',
  GET_TREND_CHART_SUCCESS: 'GET_TREND_CHART_SUCCESS',
  GET_TREND_CHART_FAILURE: 'GET_TREND_CHART_FAILURE',
  GET_USER_NOTES_SUCCESS: 'GET_USER_NOTES_SUCCESS',
  GET_USER_NOTES_FAILURE: 'GET_USER_NOTES_FAILURE',

  GET_CURRENT_PROFILE_SUCCESS: 'GET_CURRENT_PROFILE_SUCCESS',
  GET_CURRENT_PROFILE_FAILURE: 'GET_CURRENT_PROFILE_FAILURE',
  UPDATE_CURRENT_PROFILE_SUCCESS: 'UPDATE_CURRENT_PROFILE_SUCCESS',
  UPDATE_CURRENT_PROFILE_FAILURE: 'UPDATE_CURRENT_PROFILE_FAILURE',

  GET_CURRENT_USER_PERMISSIONS_SUCCESS: 'GET_CURRENT_USER_PERMISSIONS_SUCCESS',
  GET_CURRENT_USER_PERMISSIONS_FAILURE: 'GET_CURRENT_USER_PERMISSIONS_FAILURE',

  INIT_SESSION: 'INIT_SESSION',
  RESET_SESSION: 'RESET_SESSION',
  INACTIVITY_INCREMENT: 'INACTIVITY_INCREMENT',
  DESTROY_SESSION: 'DESTROY_SESSION',
  LOG_API: 'LOG_API',

  GET_SERVER_VERSION_SUCCESS: 'GET_SERVER_VERSION_SUCCESS',
  GET_SERVER_VERSION_FAILURE: 'GET_SERVER_VERSION_FAILURE',

  GETTING_MP: 'GETTING_MP',
  END_GETTING_MP: 'END_GETTING_MP',
  GET_MP_SUCCESS: 'GET_MP_SUCCESS',
  GET_MP_FAILURE: 'GET_MP_FAILURE',

  LOOKUP_GROUPS_SUCCESS: 'LOOKUP_GROUPS_SUCCESS',
  LOOKUP_GROUPS_FAILURE: 'LOOKUP_GROUPS_FAILURE',
  LOOKUP_DEPARTMENTS_SUCCESS: 'LOOKUP_DEPARTMENTS_SUCCESS',
  LOOKUP_DEPARTMENTS_FAILURE: 'LOOKUP_DEPARTMENTS_FAILURE',
  LOOKUP_ROLES_SUCCESS: 'LOOKUP_ROLES_SUCCESS',
  LOOKUP_ROLES_FAILURE: 'LOOKUP_ROLES_FAILURE',
  LOOKUP_GROUPS_FOR_SCHEDULED_REPORTS_SUCCESS:
    'LOOKUP_GROUPS_FOR_SCHEDULED_REPORTS_SUCCESS',
  LOOKUP_GROUPS_FOR_SCHEDULED_REPORTS_FAILURE:
    'LOOKUP_GROUPS_FOR_SCHEDULED_REPORTS_FAILURE',
  LOOKUP_BR_GROUPS_BY_DEPT_SUCCESS: 'LOOKUP_BR_GROUPS_BY_DEPT_SUCCESS',
  LOOKUP_BR_GROUPS_BY_DEPT_FAILURE: 'LOOKUP_BR_GROUPS_BY_DEPT_FAILURE',
  LOOKUP_USERS_SUCCESS: 'LOOKUP_USERS_SUCCESS',
  LOOKUP_USERS_FAILURE: 'LOOKUP_USERS_FAILURE',
  LOOKUP_TIMEZONES_SUCCESS: 'LOOKUP_TIMEZONES_SUCCESS',
  LOOKUP_TIMEZONES_FAILURE: 'LOOKUP_TIMEZONES_FAILURE',

  CHECK_DEPARTMENT_LICENSE_ONCE: 'CHECK_DEPARTMENT_LICENSE_ONCE',
  SET_LICENSE_EXPIRATION: 'SET_LICENSE_EXPIRATION',
  SHOW_LICENSE_EXPIRATION_NOTIFICATION: 'SHOW_LICENSE_EXPIRATION_NOTIFICATION',
};
